import { SVLoader } from '@/components/core';
import DefaultLayout from '@/components/layouts/DefaultLayout';
import StaffForm from '@/components/staff/StaffForm';
import { ROUTES } from '@/constants/routes';
import { useGetStaffDetails } from '@/hooks/requests/useStaff';
import { Card, Typography } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';

export default function StaffEdit() {
  const { uuid = '' } = useParams();
  const navigate = useNavigate();
  const { staffDetails, isStaffDetailsPending } = useGetStaffDetails(uuid);

  if (isStaffDetailsPending) {
    return (
      <DefaultLayout header="Staff Details">
        <SVLoader />
      </DefaultLayout>
    );
  }

  if (!staffDetails) {
    return (
      <DefaultLayout header="Staff Details">
        <Card>
          <Typography>
            Something went wrong retreiving the staff member. Our team has been
            notified.
          </Typography>
        </Card>
      </DefaultLayout>
    );
  }

  return (
    <DefaultLayout
      header={`Edit ${staffDetails.firstName} ${staffDetails.lastName}`}>
      <StaffForm
        isEdit
        defaultValues={{
          uuid,
          firstName: staffDetails.firstName,
          lastName: staffDetails.lastName,
          title: staffDetails.title,
          email: staffDetails.email,
          phoneNumber: staffDetails.phoneNumber,
          businessPhoneNumber: staffDetails.businessPhoneNumber,
          bio: staffDetails.bio,
          avatarUrl:
            staffDetails.avatar && staffDetails.avatar !== 'None'
              ? staffDetails.avatar
              : '',
          avatarDisplayName: '',
          isSandboxUser: staffDetails.isSandboxUser,
          sandboxPassword: '',
        }}
        onSuccess={(uuid: string) => navigate(`${ROUTES.STAFF}/${uuid}`)}
      />
    </DefaultLayout>
  );
}
